<style>
    .overflow{
        overflow: auto;
    }
</style>
<script>

import {  onMount } from "svelte";
import Date from "./Components/Helpers/date.svelte";
import { options } from "./config";
import { loading } from "./loader";
import { GetContact } from "./Services/form0";
import { user } from "./store";
let data = {
    data:{}
}
let customer = {
    data:{}
}
export let params = {}
        onMount(()=>{
            if(params.wild){
                loading.set(true)
                GetContact(options.profile,params.wild,$user.idToken,(d)=>{
                    data = d
                    GetContact(options.profile,"customer/"+data.data.customer,$user.idToken,(d)=>{
                        customer = d
                        loading.set(false)
                    },(error)=>{
                        console.error(error)
                    })
                },(error)=>{
                    console.error(error)
                })
            }
        })
</script>
<div class="section_wrapper active">
{#if customer.data.name}
    <div class="s s25 box">
        <div class="content_area">
            <h1>Post Incident Review</h1>
            <table class="info_table">
                <tr>
                    <td>Name<h2>{customer.data.name}</h2></td>
                </tr>
                <tr>
                <td>Issue Date<h2><Date date={data.data.incidentDate}/></h2></td>
                </tr>
                <tr>
                    <td>Total Outage Time<h2>{data.data.totalOutageTime} minutes</h2></td>
                </tr>
            </table>
        </div>
    </div>
    <div class="s s75 box">
        <div class="content_area">
        <h1>{data.data.issue}</h1> 
        <p>{data.data.issueDescription}</p>
        <h2>End User Impact</h2>
        <p>{data.data.endUserImpact}</p>
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area overflow">
            <h1>Analysis</h1>
            {@html data.data.analysis}
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area overflow">
            <h1>Root Cause</h1>
            {@html data.data.rootCause}
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area overflow">
            <h1>Timeline</h1>
            {@html data.data.timeline}
        </div>
    </div>
    <div class="s s100 box">
        <div class="content_area overflow">
            <h1>Preventative Actions</h1>
            {@html data.data.preventative}
        </div>
    </div>
{/if}

</div>
